import React from "react";
import DetailListView from "../DetailListView";

export default function CalculatorTab({ viewGrid, item }) {
  return <DetailListView item={item} />;
}
